
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","fill":"#fff","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"d":"M20.102 21.533l-5.236-5.236a7.985 7.985 0 01-10.535-.67 7.989 7.989 0 010-11.289 7.98 7.98 0 0111.289 0 7.979 7.979 0 01.659 10.545l5.236 5.236a1 1 0 010 1.414 1 1 0 01-.709.295.984.984 0 01-.704-.295zM5.744 5.75a5.992 5.992 0 000 8.469 5.993 5.993 0 008.468 0 6 6 0 000-8.469 5.97 5.97 0 00-4.234-1.752A5.97 5.97 0 005.749 5.75z","fill":"inherit"}})])
          )
        }
      }
    